import clsx from "clsx";
import { HemeryLogoIcon } from "ui/iconsN";

type Props = {
  className?: string;
};
export const TagHemerys = ({ className }: Props) => {
  return (
    <div
      className={clsx(
        "w-[100px] shadow-[0px_0.8px_6.4px_rgba(0,0,0,0.6)] bg-[#12100F] rounded-[2px] border-[0.8px] border-white/15",
        className,
      )}
    >
      <HemeryLogoIcon />
    </div>
  );
};
